export default __webpack_public_path__ + "static/media/loading-animated.9d8d2a2a.svg";